import React, {useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import CardMaker from './EventMaker'
import Location from './location'
import { axiosWithAuth } from './axiosWithAuth'
import Cards from './cards'



export default function Home(){
    const [pot ,setPot] = useState([])
    const history = useHistory()
    const id = 

    useEffect(() => {
     axiosWithAuth()
         .get('/events')
         .then((res) => {
             console.log(res)
             setPot(res.data.event)
        })
    },[]);
    
    const array = [...pot];

    return(
        <div>
            <div>
                <Link to='/potluck'>
                    <button>Click here to start a potluck!</button>
                </Link>
                {/* <Link to = '/eventEdit'> 
                <button>Click here to Edit your event!</button>
                </Link> */}
           </div>
            
            <div>
                <h2>Your Events</h2>
                {/* place events here and locations here*/}
                <div >
                {array.map((event) => {
                    return (
                    <div onClick = {() => history.push(`/eventEdit/${event.id}`)}>
                    <Cards key = {event.id} data = {event} />
                    </div>
                    )
                })}
                </div>
                <br></br>
                <Location/>
            </div>
        </div>
    )
}
